const isBrowser = () => typeof window !== "undefined";

export const capturePromoteKitAttribution = () => isBrowser()
  ? (window.instantTranscriberAcquisition?.affiliateFirstTouch?.() || { affiliate_state: 'none' })
  : { affiliate_state: 'none' };

export const getPromoteKitAttributionParams = () => {
  const attribution = capturePromoteKitAttribution();
  const params = { affiliate_first_touch: attribution.affiliate_state };
  if (attribution.promotekit_referral) params.promotekit_referral = attribution.promotekit_referral;
  else if (attribution.promotekit_code_param && attribution.promotekit_code_value) {
    params[attribution.promotekit_code_param] = attribution.promotekit_code_value;
  }
  if (attribution.promotekit_via) params.via = attribution.promotekit_via;
  return params;
};

export const appendPromoteKitAttributionParams = (url) => {
  const nextUrl = url instanceof URL ? url : new URL(url);
  Object.entries(getPromoteKitAttributionParams()).forEach(([key, value]) => nextUrl.searchParams.set(key, value));
  return nextUrl;
};

export const initPromoteKitAttribution = () => {
  if (!isBrowser()) return;
  capturePromoteKitAttribution();
  [250, 1000, 2500, 5000].forEach(delay => window.setTimeout(capturePromoteKitAttribution, delay));
};
